import { Link } from 'react-router-dom';
import { Card, Button, Avatar } from '@getpay93/ui';
import { useAuth } from '../../auth/AuthContext';
import { useCoaches } from '../../data/hooks';

export function Perfil() {
  const { session, logout } = useAuth();
  const coaches = useCoaches();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Card>
        <div style={{ fontWeight: 800, fontSize: 18, color: 'var(--text-strong)' }}>{session?.user.name}</div>
        <div style={{ color: 'var(--text-hint)', fontSize: 14 }}>{session?.user.email}</div>
      </Card>

      <Card>
        <strong style={{ color: 'var(--text-strong)' }}>Mis negocios</strong>
        <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 10 }}>
          {(coaches.data ?? []).map((c) => (
            <div key={c.orgId} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <Avatar name={c.orgName} tone="solid" size="sm" />
              <div>
                <div style={{ fontWeight: 700, color: 'var(--text-body)' }}>{c.orgName}</div>
                <div style={{ fontSize: 12, color: 'var(--text-hint)', textTransform: 'capitalize' }}>{c.orgType}</div>
              </div>
            </div>
          ))}
          {coaches.data && coaches.data.length === 0 ? <span style={{ color: 'var(--text-hint)' }}>No perteneces a ningún negocio.</span> : null}
        </div>
        <div style={{ marginTop: 12 }}><Link to="/unirse" style={{ fontSize: 14 }}>+ Unirme a otro negocio</Link></div>
      </Card>

      <Card>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <Link to="/recuperar" style={{ fontSize: 14 }}>Cambiar contraseña</Link>
          <Button variant="outline" onClick={logout}>Cerrar sesión</Button>
        </div>
      </Card>
    </div>
  );
}
